import React from 'react'
import { Map, TileLayer, Marker, Popup } from 'react-leaflet'
import 'leaflet/dist/leaflet.css';
import styled from "styled-components"
import L from 'leaflet';
import theme from "../../../Theme/Theme";
import {baseUrl} from "../../../Constants/constants";
import {Link} from "react-router-dom";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

const StyledMap = styled(Map)`
  height: 600px;
  margin: 2rem 0;
`;

const PopupWrapper = styled.div`
  h2 {
    font-family: Inter;
    font-weight: 700;
    font-size: 18px;
    color: #0A1F44;
    line-height: 32px;
  }
  .item {
    border-bottom: 1px solid ${theme.colors.grayLight};
    display: flex;
    align-items: center;
    margin: .5rem 0;
    padding-bottom: .5rem;
    
    p {
      margin: 0;
      font-size: 14px;
      margin-left: .5rem;
      font-family: Inter;
      font-weight: 600;
      color: #009BDF !important;
      max-width: 255px;
    }
    .image-cropper {
      width: 30px;
      height: 30px;
      position: relative;
      overflow: hidden;
      border-radius: 50%;
    }
    img {
      display: inline;
      margin: 0 auto;
      margin-left: -25%; //centers the image
      height: 100%;
      width: auto;
    }
  }
`;

export default function MapView(props) {

  const state = {
    lat: 51.505,
    lng: -0.09,
    zoom: 2,
  };

  function renderPopUp( org ) {
    let stories = [];

    props.stories.forEach( story => {
      if (story.field_organization.id === org.id) {
        stories.push(story);
      }
    });

    return (
      <PopupWrapper>
        <h2>{org.name }</h2>
        { stories.map( ((story,i) => {
          return (
            <Link key={story.id + i} to={ "/stories/" + encodeURI(story.title)} className={'item'}>
              <div className={'image-cropper'}>
                <img src={ baseUrl + story.field_banner_image.uri.url} />
              </div>
              <p key={story.id + i}>{story.title }</p>
            </Link>
          )
        }))}
      </PopupWrapper>
    )
  }

  return (
    <StyledMap
      center={[state.lat, state.lng]}
      zoom={state.zoom}
      style={{ height: '400px'}}
    >
      <TileLayer
        attribution="Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
        url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
      />

      {
        props.orgs.map( ( org, i) => {
          if (org.field_location.lat && org.field_location.lng) {
            return (
              <Marker
                key={org.id + i}
                position={[org.field_location.lat, org.field_location.lng]}
              >
                <Popup>
                  { renderPopUp(org)}
                </Popup>
              </Marker>
            )
          }
          else {
            return null
          }
        })
      }

    </StyledMap>
  )
}
